import template from "./wide-table-banner.html";
import "./wide-table-banner.less";

const WIDE_MODE_MIN_WIDTH = 1200;

function controller($element, $scope, $userProfile, uiState, $timeout, $window) {
	const ctrl = this;
	let observer = null;

	ctrl.$onInit = onInit;
	ctrl.$onDestroy = onDestroy;
	ctrl.enableWideMode = enableWideMode;
	ctrl.dismissBanner = dismissBanner;
	ctrl.showBanner = false;

	function onInit() {
		const profile = $userProfile.getUserProfile();
		if(!profile || profile.wideTableDisplay !== undefined) {
			return;
		}

		scheduleOverflowCheck();
	}

	function scheduleOverflowCheck() {
		$timeout(() => {
			checkOverflow();

			const scrollContainer = findScrollContainer();
			if(scrollContainer && typeof ResizeObserver !== "undefined") {
				observer = new ResizeObserver(() => {
					$scope.$evalAsync(() => checkOverflow());
				});
				observer.observe(scrollContainer);
			}
		}, 500);
	}

	function findScrollContainer() {
		const parent = $element[0].parentElement;
		if(!parent)return null;
		return parent.querySelector("[grid-data]") || parent.querySelector(".overflow-auto");
	}

	function checkOverflow() {
		if($window.innerWidth < WIDE_MODE_MIN_WIDTH) {
			ctrl.showBanner = false;
			return;
		}

		const container = findScrollContainer();
		if(!container)return;

		const hasOverflow = container.scrollWidth > container.clientWidth;
		if(hasOverflow !== ctrl.showBanner) {
			ctrl.showBanner = hasOverflow;
		}
	}

	function enableWideMode() {
		const profile = $userProfile.getUserProfile();
		profile.wideTableDisplay = true;
		uiState.wideTableMode = true;
		$userProfile.setUserProfile(profile);
		ctrl.showBanner = false;
	}

	function dismissBanner() {
		const profile = $userProfile.getUserProfile();
		profile.wideTableDisplay = false;
		$userProfile.setUserProfile(profile);
		ctrl.showBanner = false;
	}

	function onDestroy() {
		if(observer) {
			observer.disconnect();
		}
	}
}

export default angular
	.module("vesl.components.wide-table-banner", [])
	.component("wideTableBanner", { template, controller }).name;
